const chunkMapping = {
	"90": [
		4090
	],
	"198": [
		9198
	],
	"287": [
		4287
	],
	"309": [
		2309
	],
	"346": [
		6346
	],
	"363": [
		7363
	],
	"368": [
		1368
	],
	"387": [
		9387
	],
	"391": [
		9391
	],
	"435": [
		435
	],
	"437": [
		6437
	],
	"460": [
		6460
	],
	"488": [
		5488
	],
	"497": [
		1497
	],
	"525": [
		525
	],
	"579": [
		8579
	],
	"580": [
		1580
	],
	"629": [
		8629
	],
	"647": [
		9647
	],
	"726": [
		9726
	],
	"810": [
		2810
	],
	"827": [
		9827
	],
	"889": [
		6889
	],
	"952": [
		2952
	],
	"955": [
		7955
	],
	"963": [
		9963
	]
};
const idToExternalAndNameMapping = {
	"435": [
		"default",
		"./Accordion",
		1008
	],
	"525": [
		"default",
		"./Form",
		1008
	],
	"1368": [
		"default",
		"./Tooltip",
		1008
	],
	"1497": [
		"default",
		"./Input",
		1008
	],
	"1580": [
		"default",
		"./Leaderboard",
		1008
	],
	"2309": [
		"default",
		"./ErrorFallback",
		1008
	],
	"2810": [
		"default",
		"./FileUpload",
		1008
	],
	"2952": [
		"default",
		"./Header",
		1008
	],
	"4090": [
		"default",
		"./Spinner",
		1008
	],
	"4287": [
		"default",
		"./Autocomplete",
		1008
	],
	"5488": [
		"default",
		"./Checkbox",
		1008
	],
	"6346": [
		"default",
		"./Buttons",
		1008
	],
	"6437": [
		"default",
		"./Card",
		1008
	],
	"6460": [
		"default",
		"./Slider",
		1008
	],
	"6889": [
		"default",
		"./Datepicker",
		1008
	],
	"7363": [
		"default",
		"./Search",
		1008
	],
	"7955": [
		"default",
		"./Dialog",
		1008
	],
	"8579": [
		"default",
		"./RadioButtons",
		1008
	],
	"8629": [
		"default",
		"./Table",
		1008
	],
	"9198": [
		"default",
		"./Footer",
		1008
	],
	"9387": [
		"default",
		"./Dropdowns",
		1008
	],
	"9391": [
		"default",
		"./Popup",
		1008
	],
	"9647": [
		"default",
		"./Switches",
		1008
	],
	"9726": [
		"default",
		"./Plot",
		1008
	],
	"9827": [
		"default",
		"./CheckboxesDropdown",
		1008
	],
	"9963": [
		"default",
		"./Map",
		1008
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			let getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			const data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			const onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			const handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					const promise = fn(arg1, arg2);
					if(promise?.then) {
						const p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			const onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			const onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			const onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}